/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {GetterTree} from 'vuex';
import {RootState} from '@/store/types';
import {SettingStateInterface} from '@/store/modules/settings/types';

/**
 * The application settings module getters.ts provide entry points for stored data.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

export const getters: GetterTree<SettingStateInterface, RootState> = {
    /**
     * Gets the language.
     *
     * @param {SettingStateInterface} state
     *
     * @returns {string}
     */
    language(state: SettingStateInterface): string {
        return state.language;
    },

    /**
     * Gets the session token.
     *
     * @param {SettingStateInterface} state
     *
     * @returns {string[]}
     */
    media(state: SettingStateInterface): string[] {
        return state.media;
    },

    /**
     * Gets the session token.
     *
     * @param {SettingStateInterface} state
     *
     * @returns {string[]}
     */
    hasMedia(state: SettingStateInterface): (...name: string[]) => boolean {
        return (...name: string[]): boolean => {
            return (name.reduce((r: any, a: string) => state.media.includes(a) && r.concat(a) || r, [])).length > 0;
        };
    },

    /**
     * Consent checker.
     *
     * @param {SettingStateInterface} state
     *
     * @returns {boolean}
     */
    consented(state: SettingStateInterface): boolean {
        return state.consent;
    },

    /**
     * Page Title.
     *
     * @param {SettingStateInterface} state
     *
     * @returns {string}
     */
    pageTitle(state: SettingStateInterface): string {
        return state.pageTitle;
    },

    /**
     *  Masthead image.
     *
     * @param {SettingStateInterface} state
     *
     * @returns {string | undefined}
     */
    mastheadImage(state: SettingStateInterface): string | undefined {
        return state.mastheadImage;
    },

    /**
     *  Background image.
     *
     * @param {SettingStateInterface} state
     *
     * @returns {string | undefined}
     */
    backgroundImage(state: SettingStateInterface): string | undefined {
        return state.backgroundImage;
    },
};
